module.exports = __webpack_public_path__ + "img/caroline.38bc9e3.png";